import React, { useState } from 'react';
import './Contact.css';
import { db } from '../../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    role: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ show: false, type: '', message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validateForm = () => {
    const { name, phone, message } = formData;
    if (!name || !phone || !message) {
      setNotification({
        show: true,
        type: 'error',
        message: 'Please fill in all fields'
      });
      return false;
    }
    if (!/^[0-9]{10}$/.test(phone.replace(/\D/g, ''))) {
      setNotification({
        show: true,
        type: 'error',
        message: 'Please enter a valid 10-digit phone number'
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      // Save to Firestore
      await addDoc(collection(db, 'contactMessages'), {
        name: formData.name,
        email: formData.email || '',
        phone: formData.phone,
        role: formData.role || '',
        message: formData.message,
        status: 'unread',
        createdAt: serverTimestamp()
      });

      setNotification({
        show: true,
        type: 'success',
        message: 'ಧನ್ಯವಾದಗಳು! ನಿಮ್ಮ ಸಂದೇಶವನ್ನು ಸ್ವೀಕರಿಸಲಾಗಿದೆ. ನಾವು ಶೀಘ್ರವೇ ನಿಮಗೆ ಪ್ರತಿಕ್ರಿಯೆ ನೀಡುತ್ತೇವೆ.'
      });
      setFormData({
        name: '',
        email: '',
        phone: '',
        role: '',
        message: ''
      });
    } catch (error) {
      console.error('Error saving contact message:', error);
      setNotification({
        show: true,
        type: 'error',
        message: 'ಏನೋ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <h1>ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ</h1>
          <p>ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳು ಅಥವಾ ಬೆಂಬಲಕ್ಕಾಗಿ ನಮ್ಮ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ</p>
        </div>
      </section>

      {/* Contact Info Section - Updated to match images */}
      <section className="contact-info">
        <div className="container">
          <div className="info-grid">
            {/* Call Us Card */}
            <div className="info-card">
              <div className="info-icon">
                <i className="fas fa-phone-alt"></i>
              </div>
              <h3>ನಮ್ಮನ್ನು ಕರೆ ಮಾಡಿ</h3>
              <div className="info-details">
                <p className="info-text">+91 99026 71238</p>
                <p className="info-text">+91 89712 21976</p>
              </div>
            </div>
            {/* Email Us Card */}
            <div className="info-card">
              <div className="info-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <h3>ಇಮೇಲ್ ಮಾಡಿ</h3>
              <div className="info-details">

                <p className="info-text">info@muktankartraders.com</p>
                <p className="info-text">support@muktankartraders.com</p>
              </div>
            </div>
            {/* Visit Us Card */}
            <div className="info-card">
              <div className="info-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <h3>ನಮ್ಮನ್ನು ಭೇಟಿ ಮಾಡಿ</h3>
              <div className="info-details">

                <p className="info-text">ಮುಕ್ತಂಕಾರ ವ್ಯಾಪಾರ ಕೇಂದ್ರ</p>
                <p className="info-text">ಕೋಟ್ಯಾಳ್, ತಾ- ತಿಕೋಟಾ ಜಿ- ವಿಜಯಪುರ</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Collection Centers Section - Added based on images */}
      <section className="collection-centers-section">
        <div className="container">
          <h2>ನಮ್ಮ ಸಂಗ್ರಹ ಕೇಂದ್ರಗಳು</h2>
          <p>ನಿಮ್ಮ ಪ್ರದೇಶದ ಹತ್ತಿರದ ಸಂಗ್ರಹ ಕೇಂದ್ರವನ್ನು ಹುಡುಕಿ</p>
          <div className="collection-centers-grid">
            {/* Kotyal Center */}
            <div className="collection-center-card">
              <h3>ಕೋಟ್ಯಾಳ್ ಕೇಂದ್ರ</h3>
              <p><i className="fas fa-map-marker-alt"></i> ಕೋಟ್ಯಾಳ್, ತಿಕೋಟಾ, ವಿಜಯಪುರ, ಕರ್ನಾಟಕ</p>
              <p><i className="fas fa-phone-alt"></i> +91 99026 71238</p>
              <p><i className="fas fa-clock"></i> ಬೆಳಗಿನ 6:00 - ರಾತ್ರಿ 8:00</p>
            </div>
            {/* Dashyal Center */}
            <div className="collection-center-card">
              <h3>ದಶ್ಯಾಳ್ ಕೇಂದ್ರ</h3>
              <p><i className="fas fa-map-marker-alt"></i> ದಶ್ಯಾಳ್ (ಕೋಟ್ಯಾಳ್)</p>
              <p><i className="fas fa-phone-alt"></i> +91 9902671238</p>
              <p><i className="fas fa-clock"></i> ಬೆಳಗಿನ 6:00 - ರಾತ್ರಿ 7:00</p>
            </div>
            {/* Tokita Center */}
            <div className="collection-center-card">
              <h3>ತಿಕೋಟಾ ಕೇಂದ್ರ</h3>
              <p><i className="fas fa-map-marker-alt"></i> ತಿಕೋಟಾ ವಿಜಯಪುರ</p>
              <p><i className="fas fa-phone-alt"></i> +91 8971221976</p>
              <p><i className="fas fa-clock"></i> ಬೆಳಗಿನ 5:30 - ರಾತ್ರಿ 8:30</p>
            </div>
          </div>
        </div>
      </section>


      {/* Frequently Asked Questions Section - Added based on images */}
      <section className="faq-section">
        <div className="container">
          <h2>ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು</h2>
          <div className="faq-grid">
            {/* FAQ Item 2 */}
            <div className="faq-item">
              <h3>ನೋಂದಣಿಗೆ ಯಾವ ದಾಖಲೆಗಳು ಬೇಕಾಗುತ್ತವೆ?</h3>
              <p>ನೋಂದಣಿಗೆ ನಿಮ್ಮ ಆಧಾರ್ ಕಾರ್ಡ್, ಜಮೀನು ದಾಖಲೆಗಳು ಮತ್ತು ಬ್ಯಾಂಕ್ ಖಾತೆ ವಿವರಗಳು ಬೇಕಾಗುತ್ತವೆ.</p>
            </div>
            {/* FAQ Item 3 */}
            <div className="faq-item">
              <h3>ನನ್ನ ಉತ್ಪನ್ನಗಳನ್ನು ಹೇಗೆ ಮಾರಾಟ ಮಾಡಬೇಕು?</h3>
              <p>ನೋಂದಣಿಯ ನಂತರ, ನೀವು ನಿಮ್ಮ ಉತ್ಪನ್ನಗಳನ್ನು ನಮ್ಮ ಯಾವುದೇ ಸಂಗ್ರಹ ಕೇಂದ್ರಕ್ಕೆ ತರಬಹುದು ಅಥವಾ ಪಿಕಪ್ ಸೇವೆಯನ್ನು ವಿನಂತಿಸಬಹುದು.</p>
            </div>
            {/* FAQ Item 4 */}
            <div className="faq-item">
              <h3>ಪಾವತಿ ಯಾವಾಗ ಸಿಗುತ್ತದೆ?</h3>
              <p>ಪಾವತಿಗಳನ್ನು 24-48 ಗಂಟೆಗಳೊಳಗೆ ನಿಮ್ಮ ನೋಂದಾಯಿತ ಬ್ಯಾಂಕ್ ಖಾತೆಗೆ ನೇರವಾಗಿ ಸಂಸ್ಕರಿಸಲಾಗುತ್ತದೆ.</p>
            </div>
          </div>
        </div>
      </section>


      {/* Contact Form Section - Modified to match images */}
      <section className="contact-form-section">
        <div className="container">
          <div className="form-container">
            <div className="form-content">
              <h2>ನಮಗೆ ಸಂದೇಶ ಕಳುಹಿಸಿ</h2>
              <p>ಕೆಳಗಿನ ಫಾರ್ಮ್ ಅನ್ನು ಭರ್ತಿ ಮಾಡಿ, ನಾವು ಶೀಘ್ರವೇ ನಿಮಗೆ ಪ್ರತಿಕ್ರಿಯೆ ನೀಡುತ್ತೇವೆ</p>
              {notification.show && (
                <div className={`notification ${notification.type}`}>
                  {notification.message}
                  <button
                    className="close-notification"
                    onClick={() => setNotification({ show: false, type: '', message: '' })}
                    aria-label="Close notification"
                  >
                    ×
                  </button>
                </div>
              )}
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">ಪೂರ್ಣ ಹೆಸರು</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      aria-required="true"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">ಫೋನ್ ಸಂಖ್ಯೆ</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      aria-required="true"
                      pattern="[0-9]{10}"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="message">ನಿಮ್ಮ ಸಂದೇಶ</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    aria-required="true"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="submit-btn"
                  disabled={loading}
                  aria-busy={loading}
                >
                  {loading ? (
                    <>
                      <i className="fas fa-spinner fa-spin"></i>
                      ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-paper-plane"></i>
                      ಸಂದೇಶ ಕಳುಹಿಸಿ
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact; 